export const formatCellPhoneNumber = (phone: string) => {
  const ddd = phone.substring(0, 2);
  const firstSection = phone.substring(2, 7);
  const secondSection = phone.substring(7);

  return `(${ddd})  ${firstSection}-${secondSection}`;
};
